module.exports = __webpack_public_path__ + "site/img/email.21cc2056.png";